import useClaimedPlaygroundSbt from '@/ui/hooks/use-claimed-playground-sbt';
import useNfts from '@/ui/hooks/use-nfts';
import type { Nft } from '@/ui/types';

const SPAM_THRESHOLD = 20;

function useCollectibles() {
  const { data: sbtData, loading: sbtLoading } = useClaimedPlaygroundSbt();
  const { data: nftsData, loading: nftsLoading } = useNfts();

  const loading = nftsLoading || sbtLoading;

  const nfts = nftsData
    ? Object.values(nftsData)
        .flat()
        .filter(
          (nft) =>
            nft.contractAddress?.toLowerCase() !==
              sbtData?.contractAddress?.toLowerCase() &&
            (nft.isSpam === undefined || nft.isSpam === false) &&
            (nft.spamScore === undefined || nft.spamScore <= SPAM_THRESHOLD),
        )
    : ([] as Nft[]);

  return { loading, nfts, sbt: sbtData };
}

export default useCollectibles;
